import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';

export interface NumberButtonSignature {
  // The arguments accepted by the component
  Args: {
    num: number | string;
    addNumber: (num: number | string) => void;
    display?: string;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLButtonElement;
}

<template>
  <button
    ...attributes
    type="button"
    class="inline-flex m-1 items-center justify-center w-16 h-16 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
    {{on "click" (fn @addNumber @num)}}
  >
    {{if @display @display @num}}
  </button>
</template> satisfies TOC<NumberButtonSignature>;
